import { render } from "./managementTeam.vue?vue&type=template&id=767d391b&scoped=true"
import script from "./managementTeam.vue?vue&type=script&lang=js"
export * from "./managementTeam.vue?vue&type=script&lang=js"

import "./managementTeam.vue?vue&type=style&index=0&id=767d391b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767d391b"]])

export default __exports__